import {
  TFormSubmissionFieldForLayout,
  TPreChatFormFieldLayoutSource,
  EPreChatFormFieldKeys,
} from '~/features/preChatForms/models'
import {
  buildPreChatFormFieldLayout,
  sortPreChatFormFields,
} from '~/features/preChatForms/utils'

export function formatFormSubmissionFieldValue(value: unknown): {
  text: string
  isMissing: boolean
} {
  if (value === null || value === undefined) {
    return { text: 'Not provided', isMissing: true }
  }

  if (typeof value === 'string') {
    const trimmed = value.trim()
    if (!trimmed) {
      return { text: 'Not provided', isMissing: true }
    }
    return { text: trimmed, isMissing: false }
  }

  if (typeof value === 'boolean') {
    return { text: value ? 'Yes' : 'No', isMissing: false }
  }

  if (typeof value === 'number') {
    return { text: String(value), isMissing: false }
  }

  try {
    return { text: JSON.stringify(value), isMissing: false }
  } catch {
    return { text: 'Not provided', isMissing: true }
  }
}

const toFormSubmissionLayoutField = (
  field: TFormSubmissionFieldForLayout,
): TFormSubmissionFieldForLayout & TPreChatFormFieldLayoutSource => ({
  ...field,
  [EPreChatFormFieldKeys.sortOrder]: field.sortOrder,
  [EPreChatFormFieldKeys.fieldMapping]: field.fieldMapping,
})

export const buildFormSubmissionFieldLayout = (
  fields: TFormSubmissionFieldForLayout[],
) =>
  buildPreChatFormFieldLayout(
    sortPreChatFormFields(fields.map(toFormSubmissionLayoutField)),
  )
